import React from 'react';
import { Box, Span } from '../element';
import { NavLink } from '../link';
import { useTranslation } from 'react-i18next';

const SideBarItem = (props) => {
  const { t } = useTranslation();
  const { border, index, item, queryString, active } = props;
  const activeClass = active ? 'active' : '';
  return (
    <Box justify="start" border={border} fill={true} className="autoMinHeight">
      <NavLink
        className={'leftNavMenu ' + activeClass}
        to={item.path + queryString}
        data-test-id={`sidebar-${item.menuText}-link`}
      >
        <Span className="paddingRight3">{index + 1}</Span>
        {t(item.menuText)}
      </NavLink>
      {/* todo */}
      {/* <Route path="/physicalInstall" url="/physicalInstall" component={PhysicalInstallSteps} /> */}
    </Box>
  );
};

export default SideBarItem;
